import {gql} from 'apollo-boost';
import {STUDENT_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_STUDENTUNITLEARN = gql`
  query getStudentUnitLearn($id : ID!){
    getStudentUnitLearn (
      id: $id
    ) {
      id unitSeq totalVdoLength totalLearnTime learnPercent
      studentEnroll { id }
      studentEnrollDetail {
        id
        student {
          ...StudentNameFields
          picturePath
        }
        classSection { id }
      }
      courseOutlineUnit { id }
      vdoSetUnit { id }

      studentTopicLearns { id }

    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTUNITLEARNS_BY_FILTER = gql`

  query getStudentUnitLearnsByFilter($studentUnitLearnFilterInput: StudentUnitLearnFilterInput){
    getStudentUnitLearnsByFilter (
      studentUnitLearnFilterInput:$studentUnitLearnFilterInput
    ){
      id unitSeq totalVdoLength totalLearnTime learnPercent
      studentEnroll { id }
      studentEnrollDetail {
        id
        student {
          ...StudentNameFields
          picturePath
        }
        classSection { id }
      }
      courseOutlineUnit { id }
      vdoSetUnit { id }

      studentTopicLearns { id }

    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTUNITLEARNS = gql`
  query getStudentUnitLearns {
    getStudentUnitLearns {
      id unitSeq totalVdoLength totalLearnTime learnPercent
      studentEnroll { id }
      studentEnrollDetail {
        id
        student {
          ...StudentNameFields
          picturePath
        }
        classSection { id }
      }
      courseOutlineUnit { id }
      vdoSetUnit { id }

      studentTopicLearns { id }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const ADD_STUDENTUNITLEARN = gql`
  mutation addStudentUnitLearn(
    $classSectionId: ID!
    $studentUnitLearnInput: StudentUnitLearnInput!
  ) {
    addStudentUnitLearn(
      classSectionId: $classSectionId
      studentUnitLearnInput: $studentUnitLearnInput
    ) {
      id unitSeq totalVdoLength totalLearnTime learnPercent
      studentEnroll { id }
      studentEnrollDetail {
        id
        student {
          ...StudentNameFields
          picturePath
        }
        classSection { id }
      }
      courseOutlineUnit { id }
      vdoSetUnit { id }

      studentTopicLearns { id }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_STUDENTUNITLEARN = gql`
  mutation updateStudentUnitLearn(
    $id: ID!,
    $studentUnitLearnInput: StudentUnitLearnInput!
  ) {
    updateStudentUnitLearn(
      id: $id
      studentUnitLearnInput: $studentUnitLearnInput
    ) {
      id unitSeq totalVdoLength totalLearnTime learnPercent
      studentEnroll { id }
      studentEnrollDetail {
        id
        student {
          ...StudentNameFields
          picturePath
        }
        classSection { id }
      }
      courseOutlineUnit { id }
      vdoSetUnit { id }

      studentTopicLearns { id }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

